import React, { memo } from "react";
import { useQuery } from "react-query";

interface IProps {
  fetchData: {
    limit: number;
    [key: string]: any;
  };
  title: string | React.ReactNode;
  fetchFun: (any) => any;
  fetchKey: string;
}

const ArticlesRank: React.FC<IProps> = ({ fetchData, title, fetchFun, fetchKey }) => {

  const { data } = useQuery(`fetchFun-${fetchKey}`, async () => {
    const res = await fetchFun(fetchData);
    if (res?.status === 12000) {
      return res.data.list;
    }
    return [];
  });

  if (!data?.length) return null;

  return (
    <div className="w-[334px] py-20 px-0">
      <div className="text-left text-[#333333] leading-[30px] mb-20">
        {title}
      </div>
      <div className="flex flex-col">
        {data.map((item, i) => (
          <a
            key={item.id}
            title={item.title}
            href={item.link}
            target='_blank'
            className={`${i <= 2 ? "font-[700]" : ""} text-16 text-left text-[#333333] leading-[20px] mb-14 line-clamp-1`}
          >
            <span
              className={`${i <= 2 ? "text-[#333] text-20 leading-[12px]" : "text-[#bbb] leading-[18px]"} inline-block w-18 h-18 rounded-10 text-center mr-14 italic font-bold`}
              style={{ background: i === 0 ? "linear-gradient(360deg, #ffe084, #ffbe4d)" : i === 1 ? "linear-gradient(360deg, #e0e0e0, #c0c0c0)" : i === 2 ? "linear-gradient(360deg, #ffbe96, #ff6d2f)" : "" }}
            >
              {i + 1}
            </span>
            {item.title}
          </a>
        ))}
      </div>
    </div>
  );
};

export default memo(ArticlesRank);
